<template>
  <div class="CoalModel_box">
    <div v-if="!isDetail">
      <!-- 搜索 -->
      <div class="CoalModel_box_title">
        <div class="CoalModel_box_title_desc">车辆管理</div>
      </div>
      <el-divider></el-divider>
      <el-form :inline="true" :model="filterForm" class="demo-form-inline" ref="form" size="small">
        <el-form-item label>
          <el-input placeholder="请输入车牌号" v-model="filterForm.carLicensePlateNo" clearable></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input placeholder="请输入车辆类型" v-model="filterForm.model" clearable></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input placeholder="请输入卸货方式" v-model="filterForm.unloadingWay" clearable></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input placeholder="请输入绑定司机" v-model="filterForm.bindDriverName" clearable></el-input>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.status" placeholder="状态" filterable clearable>
            <el-option
              v-for="item in stateList"
              :key="item.code"
              :value="item.code"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            @click="handleSearch()"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button icon="fa fa-share" label="重置" perms="-1" @click="getReset" type="primary" />
        </el-form-item>
      </el-form>
      <!-- 车辆管理列表 -->
      <el-table v-loading="loading" :data="carList" stripe size="mini" style="width: 100%">
        <el-table-column type="index" align="center" width="80" fixed label="序号"></el-table-column>
        <el-table-column prop="carLicensePlateNo" align="center" label="车牌号"></el-table-column>
        <el-table-column prop="model" align="center" label="车辆类型"></el-table-column>
        <el-table-column prop="unloadingWay" align="center" label="卸货方式"></el-table-column>
        <el-table-column prop="bindDriverName" align="center" label="绑定司机"></el-table-column>
        <el-table-column prop="statusDesc" align="center" label="状态"></el-table-column>
        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <kt-button
              v-if="scope.row.status === 2"
              label="审核"
              icon="fa fa-edit"
              perms="30500"
              @click="checkComponent(scope.row,true)"
              type="primary"
            />
            <kt-button
              label="查看"
              perms="-1"
              icon="fa fa-edit"
              v-if="scope.row.status !== 2"
              @click="checkComponent(scope.row,false)"
            />
            <kt-button
              label="解绑"
              perms="30502"
              type="danger"
              icon="el-icon-link"
              v-if="scope.row.status == 0"
              @click="handleUnbind(scope.row,false)"
            />
            <kt-button    
              label="修改"
              perms="3051"
              type="primary"
              icon="fa fa-edit"
              @click="handleUpdate(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding:20px;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="float:right;"
        ></el-pagination>
      </div>
    </div>
    <!--查看详情-->
    <CarDetail 
      v-if="isDetail"
      :carLicensePlateNo="carLicensePlateNo"
      :carId="carId"
      @detailFun="detailFun" />
      <el-dialog title="车辆信息修改" :visible.sync="isShowDialog" v-if="isShowDialog">
      <el-form :model="currentRow" ref="ruleForm" label-width="120px" class="demo-ruleForm" size="mini">
        <el-form-item label="车牌号" prop="carLicensePlateNo" required>
          <el-input v-model="currentRow.carLicensePlateNo" style="width: 200px" clearable disabled></el-input>
        </el-form-item>
        <el-form-item label="车辆类型" prop="model" required>
          <el-select v-model="currentRow.model1"  placeholder="车辆类型">
            <el-option v-for="item in model1List" :key="item.index" :value="item.label" :label="item.label"></el-option>
          </el-select>
          <el-select v-model="currentRow.model2"  placeholder="车辆类型">
            <el-option v-for="item in model2List" :key="item.index" :value="item.label" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卸货方式" prop="unloadingWay" required>
          <el-select v-model="currentRow.unloadingWay"  placeholder="卸货方式">
            <el-option v-for="item in unloadingWayList" :key="item.index" :value="item.label" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行驶证正反面" prop="idCardImg">
          <div class="list">
            <div class="list_right">
              <UploadImg
                :imageUrl='currentRow.drivingLicenceFrontImg'
                ref='drivingLicenceFrontImg'
                name='行驶证正面'
                domKeys="drivingLicenceFrontImg"
                @setImgUrl="handleChangeImg"
                @setDomKeys="submitUpload"
              />
              <el-button style="margin-top: 10px" type="info" @click="submitUpload('drivingLicenceFrontImg')">点击上传</el-button>
            </div>
            <div class="list_right">
              <UploadImg
                :imageUrl='currentRow.drivingLicenceBackImg'
                ref='drivingLicenceBackImg'
                name='行驶证反面'
                domKeys="drivingLicenceBackImg"
                @setImgUrl="handleChangeImg"
                @setDomKeys="submitUpload"
              />
              <el-button style="margin-top: 10px" type="info" @click="submitUpload('drivingLicenceBackImg')">点击上传</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="道路运输证正面" prop="idCardImg">
          <div class="list">
            <div class="list_right">
              <UploadImg
                :imageUrl='currentRow.roadTransportationImg'
                ref='roadTransportationImg'
                name='行驶证正面'
                domKeys="roadTransportationImg"
                @setImgUrl="handleChangeImg"
                @setDomKeys="submitUpload"
              />
              <el-button style="margin-top: 10px" type="info" @click="submitUpload('roadTransportationImg')">点击上传</el-button>
            </div>
            
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" style="margin-right: 20px" @click="submitForm">保存</el-button>
        <el-button @click="(isShowDialog= false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/Core/KtButton";
import CarDetail from "./CarDetail";
import UploadImg from '@/components/Core/UploadImg'

export default {
  components: {
    KtButton,
    CarDetail,
    UploadImg
  },
  data() {
    return {
      isShow: false,
      driverNo: "",
      size: "small",
      loading: false,
      filterForm: {
        carLicensePlateNo: "",
        model: "",
        unloadingWay: "",
        status: ""
      },
      stateList: [
        {
          code: '0',
          name: '已启用'
        },
        {
          code: '2',
          name: '待审核'
        },
        {
          code: '3',
          name: '审核驳回'
        },
        {
          code: '99',
          name: '已删除'
        }
      ],
      model1List:[{
        label: '单桥',
      },{
        label: '双桥'
      }],
      model2List: [{
        label: '燃油'
      },{
        label: '燃气'
      }],
      unloadingWayList:[{
        label: '侧翻'
      },{
        label: '后翻'
      },{
        label: '平板'
      }],
      isShowDialog:false,
      carList: [],
      isDetail: false,
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      carLicensePlateNo: '',
      carId: 0,
      currentRow: {}
    };
  },
  mounted() {
    this.getCarList();
  },
  methods: {
    // 获取司机列表
    async getCarList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          params["searchFieldList[" + index + "].singleValue"] = val;
          index++;
        }
      }
      let res = await this.$api.carModel.mGetCarList(params);

      this.carList = !res.data.dtoList ? [] : res.data.dtoList;
      this.totalSize = res.data.totalSize;
    },
    async handleUpdate(row){
      let _t = this
      let res = await _t.$api.carModel
        .admCarDetail({
          carLicensePlateNo: row.carLicensePlateNo,
          id: row.id
        })
      this.currentRow = res.data
      let modelArr = res.data.model.split('、')
      this.currentRow.model1 = modelArr[0]
      this.currentRow.model2 = modelArr[1]
      this.isShowDialog =true
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getCarList();
    },

    // 重置
    getReset() {
      this.filterForm = {
        carLicensePlateNo: "",
        model: "",
        unloadingWay: "",
        status: ""
      };

      this.pageNo = 1;
      this.getCarList();
    },

    //查看车辆详情
    checkComponent(val, flag) {
      this.carLicensePlateNo = val.carLicensePlateNo;
      this.carId = val.id;
      this.isShow = flag;
      this.isDetail = true;
    },

    // 解绑车辆
    async handleUnbind(row){
      try {
        let confirm = await this.$confirm(`是否解绑车辆：${row.carLicensePlateNo}？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })

        console.log(confirm)
        if(!confirm) return;
        await this.$api.carModel.mUnbind({
          carLicensePlateNo: row.carLicensePlateNo
        })

        this.$message({
          message: "解绑成功!",
          type: "success"
        });
        this.getCarList();
      } catch (error) {
        console.log(error)
      }

    },

    detailFun(val) {
      this.isDetail = false;
      this.getCarList();
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getCarList();
    },
    handleChangeImg(res){
      console.log(res)
      this.currentRow[this.domKeys] = res
    },
    submitUpload(ref){
      console.log(ref)
      this.domKeys = ref
      this.$refs[ref].submitUpload()
    },
    async submitForm(){
      if(!this.currentRow.carLicensePlateNo){
        this.$message({
          type: 'error',
          message: '请输入修改后车牌号',
          offset:300
        })
        return 
      }
      if(!this.currentRow.drivingLicenceFrontImg){
        this.$message({
          type: 'error',
          message: '请上传修改后行驶证正面',
          offset:300
        })
        return 
      }
      if(!this.currentRow.drivingLicenceBackImg){
        this.$message({
          type: 'error',
          message: '请上传修改后行驶证反面',
          offset:300
        })
        return 
      }
      console.log(this.currentRow)
      let params = {
        ...this.currentRow
      }
      params.model = this.currentRow.model1 + '、'+ this.currentRow.model2
      let res = await this.$api.carModel.updateCarInfo({
        ...params
      })
      this.$message({
        type: 'success',
        message: '修改成功',
        offset: 300
      })
      this.isShowDialog = false
      this.getCarList();
    }
  }
};
</script>
<style lang="scss">

.CoalModel_box {
  box-sizing: border-box;
  padding: 10px;
  .CoalModel_box_title {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0 0;

    .CoalModel_box_title_desc {
      font-size: 18px;
      font-weight: 600;
    }

    .CoalModel_box_title_cz {
      color: #25aff3;
      cursor: pointer;
    }
  }

  .CoalModel_box_dialog {
    display: flex;
    justify-content: space-around;

    .CoalModel_box_dialog_nr {
      width: 33%;

      div:first-child {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
      }
    }
  }

  .CoalModel_box_dialog_nr_ts {
    text-align: center;
    margin-top: 20px;
    font-weight: 600;
    font-size: 16px;
  }
}

.list{
  display: flex;
}
.list_right{
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}
.uploader{
  display: flex;
  width: 178px;
  height: 178px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  div{
    margin-top: 10px;
    font-size: 12px;
  }
}
</style>
